export default "__VITE_ASSET__vYm629r$__"